var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cold-ns-input v-bind=\"$attrs\" :value-filters=\"myValueFilters\" :representation-filters=\"myRepresentationFilters\" v-on=\"$listeners\"\u003E\u003C\u002Fold-ns-input\u003E";;return pug_html;};
module.exports = template;